// Default values LocalUser
const defaultLocalUser: LocalUser = {
  id: '',
  name: '',
  role_id: '',
  avatar_id: '',
  status_id: '',
  type_id: '',
  owner_id: '',
  owner_team_id: '',
  tags: [],
  timezone: '',
  channels: [],
  online_status: {
    last_seen: null,
    custom_status: null,
    status: null
  },
  last_seen: '',
  created_at: '',
  updated_at: '',
  created_by: '',
  deleted_at: '',
  restricted: false,
  auth: {
    email: '',
    phone: '',
    mfa: false,
    suspended_at: null
  },
  type: {
    id: '',
    name: '',
    external: false,
    locked: false
  },
  tasks: [],
  phone: '',
  email: '',
  media_ids: [],
  media: []
}

// Changes null values to empty string in an object
const mapAPItoLocal = (obj: APIUser) => {
  const newObj: LocalUser = { ...defaultLocalUser }

  // Transfer values
  Object.keys(obj).forEach(k => {
    // Turns null values into empty strings, should be removed at some point
    if (obj[k] == null) {
      newObj[k] = ''
    } else {
      newObj[k] = obj[k]
    }
  })

  return newObj
}

// Formats number from API as `+1-XXX-XXX-XXXX`
const fixPhone = (phone: string) => {
  if (!phone) {
    return ''
  }

  if (phone.length === 15) {
    return phone
  }

  const newPhone = `${phone.length === 10 ? '+1' : ''}${phone}`
  const country = newPhone.slice(0, 2)
  const area = newPhone.slice(2, 5)
  const first = newPhone.slice(5, 8)
  const last = newPhone.slice(8)

  return `${country}-${area}-${first}-${last}`
}

// Maps APIUser type to LocalUser
export const formatUser = (user: APIUser) => {
  const newUser = mapAPItoLocal(user)

  if (newUser.restricted) {
    newUser.channels = []
  }

  // Needed for the tables
  newUser.phone =
    newUser.channels.find(({ type }) => type.includes('sms'))?.value || ''
  newUser.phone = fixPhone(newUser.phone)
  newUser.email =
    newUser.channels.find(({ type }) => type === 'email')?.value || ''

  newUser.tasks = newUser.tasks ?? []

  return newUser
}
